import { render } from "./company_verification.html?vue&type=template&id=38854da4&external"
import script from "./company_verification.js?vue&type=script&lang=js&external"
export * from "./company_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__